import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apiUrl} from '@environments/env';
import { Observable } from 'rxjs';
export interface CalendarEvent {
  id?: string;
  summary: string;
  location: string;
  description?: string;
  start: {
    dateTime: string;
    timeZone?: string;
  };
  end: {
    dateTime: string;
    timeZone?: string;
  };
  [key: string]: any; 
}
@Injectable({
  providedIn: 'root'
})
export class AgendaService {

  url = apiUrl.apiUrl + '/googleAgenda/';
  //url = 'http://localhost:4000/googleAgenda/'
  headers = { 'Content-Type': 'application/json' };


  constructor(private http: HttpClient) { }

  getUserEvents(userId: string, date: string): Observable<CalendarEvent[]> {
    console.log("getUserEvents",userId, date)
    const params = new HttpParams().set('date', date);
    return this.http.get<CalendarEvent[]>(`${this.url}/users/${userId}/events`, { params });
  }

  createUserEvent(userId: string, event: CalendarEvent): Observable<CalendarEvent> {
    return this.http.post<CalendarEvent>(`${this.url}/users/${userId}/events`, event);
  }

  deleteUserEvent(userId: string, eventId: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/users/${userId}/events/${eventId}`);
  }
}
